export enum MeasurementUnitFieldsMapping {
  'Iso_code_qualifyer' = 'codeQualifyer',
  'Isocode' = 'code',
  'Qualifyer' = 'qualifyer',
  'ABBREVIATION' = 'abbreviation',
  'Description' = 'description',
}
